import { render, staticRenderFns } from "./emr.vue?vue&type=template&id=1d5015f2&scoped=true"
import script from "./emr.vue?vue&type=script&lang=js"
export * from "./emr.vue?vue&type=script&lang=js"
import style0 from "./emr.vue?vue&type=style&index=0&id=1d5015f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5015f2",
  null
  
)

export default component.exports